import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IUserName } from '../types/IUser';
import { Request } from './Request';

export interface IGetUserNamesResult extends IGetItemsResult {
  users: IUserName[];
}

export class GetUserNamesRequest extends Request<IGetItemsParams, IGetUserNamesResult> {
  constructor(params: IGetItemsParams) {
    super('getUserNames', params);
  }
}
